import { css } from '@/styled-system/css';

export const upsellActionStyles = css.raw({
  marginBlockStart: 'Upsell.Action.margin.content-toActions',
});
